import { Component, Input } from '@angular/core';
import { TimeFilter } from '@models/filter-types';
import { Moment } from 'moment/moment';
import { FilterInputErrorStateMatcher } from '@shared/components/filters/filter-input-error-state-matcher';

@Component({
    selector: 'app-time-select',
    templateUrl: './time-select.component.html',
    styleUrls: ['./time-select.component.scss'],
    standalone: false,
})
export class TimeSelectComponent {
    @Input() property!: TimeFilter;
    @Input() icon!: string;
    @Input() disabled = false;
    @Input() val!: Moment;
    errorStateMatcher!: FilterInputErrorStateMatcher<unknown>;

    constructor() {
        (this.errorStateMatcher as FilterInputErrorStateMatcher<Moment>) = new FilterInputErrorStateMatcher(this.property);
    }
}
